<div class="chat-code-viewer" *ngIf="codeContent">
  <div class="code-header">
    <div class="code-info">
      <span class="code-language">{{ language }}</span>
      <span class="code-lines">{{ lineCount }} {{ 'chat.code-viewer.lines' | translate }}</span>
    </div>
    <div class="code-actions">
      <button
        pButton
        type="button"
        icon="pi pi-copy"
        class="p-button-sm p-button-text"
        (click)="copyCode()"
        [pTooltip]="'chat.code-viewer.copy-code' | translate"
        tooltipPosition="top"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-external-link"
        class="p-button-sm p-button-text"
        (click)="openInEditor()"
        [pTooltip]="'chat.code-viewer.open-in-editor' | translate"
        tooltipPosition="top"
      ></button>
    </div>
  </div>
  <ngx-monaco-editor
    class="monaco-editor-container"
    [style.height.px]="editorHeight"
    [options]="editorOptions"
    [ngModel]="codeContent"
    (ngModelChange)="onCodeChange($event)"
  ></ngx-monaco-editor>
</div>